export const userAccessDirectory = {
    "System Administrator": [
        "Users",
        "Distributors",
        "Customers",
        "Products",
        "Proposals",
        "Dashboard",
        "Reports",
        "Create New Report",
        "Utility Accounts",
        "Site Health",
        "Report Templates",
        "Data Inspector",
        "Data Maintenance",
        "Issue Options",
        // "Component Tree",
        "Point Mapping",
        "Connector Point Mapping",
        "Connector Admin",
        "Equipment List",
        "Equipment Dashboard",
        "Equipment Report",
        "Equipment Edit",
        "Group Report",
        "Weather Stations",
        "Generic Points",
        "Task Options"
    ],
    "Pathian Technician": [
        "Dashboard",
        "Reports",
        "Create New Report",
        "Utility Accounts",
        "Site Health",
        "Data Inspector",
        "Data Maintenance",
        "Issue Options",
        // "Component Tree",
        "Point Mapping",
        "Connector Point Mapping",
        "Connector Admin",
        "Equipment List",
        "Equipment Dashboard",
        "Equipment Report",
        "Equipment Edit",
        "Group Report",
        "Generic Points",
        "Weather Stations",
        "Task Options"
    ],
    "Pathian Account Executive": ["Distributors", "Customers", "Reports", "Create New Report"],
    "Pathian Engineer": ["Reports", "Create New Report", "Utility Accounts", "Site Health", "Report Templates", "Data Inspector", "Data Maintenance", "Point Mapping", "Connector Point Mapping", "Equipment List",
        "Equipment Dashboard", "Equipment Report", "Equipment Edit"],
    "Distributor Administrator": ["Users", "Customers", "Reports", "Create New Report", "Site Health","Equipment List",
        "Equipment Dashboard", "Equipment Report", "Equipment Edit"],
    "Account Executive": ["Customers", "Reports", "Create New Report", "Site Health","Equipment List",
        "Equipment Dashboard", "Equipment Report"],
    "Engineer": ["Reports", "Create New Report", "Site Health", "Report Templates", "Data Inspector", "Data Maintenance", "Point Mapping", "Connector Point Mapping"],
    "General User": ["Reports", "Create New Report", "Site Health"],
    "Report User": ["Reports", "Create New Report"],
};
